import React from "react";
import "./Payment_Method_Cards.css";

function Payment_Method_Cards({ cards, activeIndex, setActiveIndex }) {

  return (
    <section className="Payment_Method_Cards_holder">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`Payment_Method_Cards ${
            activeIndex === index ? "active" : ""
          }`}
          onClick={() => setActiveIndex(index)}
        >
          <div>
            <div className="img_holder">
              <img
                src={card.img}
                alt={card.title}
                className="payment_mathod_img"
              />
            </div>

            <div className="text_holder">
              <h3>{card.title}</h3>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default Payment_Method_Cards;